import { createFileRoute } from '@tanstack/react-router'
import { CREATE_ACCESS } from '../../../app/access'
import { requireAccess } from '../../../app/guards'
import { taxRatesQueryOptions } from '../../../features/finance/queries'
import { salesSettingsQueryOptions } from '../../../features/sales/queries'
import { NewQuotationPage } from '../../../features/sales/quotation-pages'
import { newQuotationSearchSchema } from '../../../features/sales/search'

export const Route = createFileRoute('/_app/quotations/new')({
  staticData: { crumb: 'quotationNew' },
  validateSearch: newQuotationSearchSchema,
  beforeLoad: ({ context }) => requireAccess(context.session, CREATE_ACCESS.quotation),
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(salesSettingsQueryOptions),
      context.queryClient.ensureQueryData(taxRatesQueryOptions),
    ])
  },
  component: NewQuotationPage,
})
